const baseWave = {
  default: {
    '& > .waveChildrenContainer': {
      backgroundColor: 'primary',
      paddingTop: 5,
      paddingBottom: 5,
      width: '100%',
      color: 'white'
    }
  }
};

const wave = {
  products: {
    chart: baseWave,
    chartblog: baseWave,
    co: baseWave,
    edu: baseWave,
    scale: baseWave,
    spark: baseWave
  }
};

export type WaveVariantsType = 'default';
export const waveVariants = Object.keys(baseWave) as WaveVariantsType[];

export default wave;
